import { Capacitor } from "@capacitor/core";

function openWithAppFallback(appUrl: string, webUrl: string) {
  if (!Capacitor.isNativePlatform()) {
    window.open(webUrl, "_blank", "noopener,noreferrer");
    return;
  }
  // Hand off to the system; if the target app is installed iOS switches away.
  // If nothing handles the scheme the page stays visible, so fall back to web.
  window.location.href = appUrl;
  setTimeout(() => {
    if (!document.hidden) {
      window.location.href = webUrl;
    }
  }, 800);
}

export function openInstagramProfile(username: string) {
  const u = encodeURIComponent(username);
  openWithAppFallback(
    `instagram://user?username=${u}`,
    `https://www.instagram.com/${u}`,
  );
}

export function openTelegramProfile(username: string) {
  const u = encodeURIComponent(username);
  openWithAppFallback(
    `tg://resolve?domain=${u}`,
    `https://t.me/${u}`,
  );
}

export function openWhatsApp(phoneOrId: string) {
  // wa.me expects digits only; strip leading + and any non-digits for safety.
  const digits = phoneOrId.replace(/\D/g, "");
  openWithAppFallback(
    `whatsapp://send?phone=${digits}`,
    `https://wa.me/${digits}`,
  );
}
